<template>
  <div>
    <list
      row-key="SectionId"
      ref="list"
      unit="展示区域管理"
      :page="page"
      :query-params="params"
      :show-toolbar="false"
      :show-query="false"
      :get-data-func="api.list"
    >
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
      <template slot="table">
        <el-table-column prop="Sort" label="区域序号" min-width="110px" />
        <el-table-column prop="SectionName" label="区域名称" min-width="110px" />
        <el-table-column prop="GoodsNumber" label="商品数量" min-width="110px" />
        <el-table-column label="展示类型" min-width="110px">
          <template slot-scope="{row}">
            <span v-if="row.GoodsType==0">最新商品</span>
            <span v-if="row.GoodsType==1">推荐商品</span>
            <span v-if="row.GoodsType==2">商品分类</span>
          </template>
        </el-table-column>
        <!-- slot[column] -->
        <slot name="column"></slot>
        <!--/ slot[column]-->
      </template>
    </list>
  </div>
</template>
<script>
import listMixin from "@/mixins/list";
import list from "@/components/common/list";

export default {
  mixins: [listMixin],
  components: { list },
  data() {
    return {
      api: require("@/api/mall/section").default,
      params: {
        SectionType: 3, //0:搜索 1:广告 2:快捷入口 3:商品
      },
    };
  },
  methods: {},
};
</script>